import { callApi, ThrowError } from '@/api/callApi';
import { API_ENDPOINT, API_URL_ORDER_SERVICE } from '@/api/constant';
import StatusDropdown from '@/components/common/StatusComponent';
import { showToastNotification } from '@/utility/helper';
import React, { useState } from 'react';
import Model from '../common/models/Model';
import ConfirmationModel from '../common/models/ConfrimationModel';
import BtnLoader from '../UI/loaders/BtnLoader';
import ErrorMessage from '../common/ErrorMessage';
import FormField from '../UI/FormField';

interface RefundDetailProp {
  status: string;
  refundId: string;
  onSucess: () => void;
}

enum RefundStatusEnum {
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
  CANCELED = 'CANCELED'
}

const RefundStatus: React.FC<RefundDetailProp> = ({
  status,
  refundId,
  onSucess,
}) => {
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [showUpdateModel, setShowUpdateModel] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [statusToUpdate, setStatusToUpdate] = useState<string | null>(null);

  const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;

    const containsNonNumeric = /[a-zA-Z]/.test(val);

    if (val.trim().length >= 5 && containsNonNumeric) {
      setErrorMessage('');
    } else {
      if (val.trim().length < 5) {
        setErrorMessage('Reason must be at least 5 characters long');
      } else if (!containsNonNumeric) {
        setErrorMessage('Reason must contain at least one letter');
      }
    }

    setRejectReason(val);
  };

  const handleChangeStatus = async (id: string, newStatus: string, rejectReason?: string) => {
    if (newStatus === RefundStatusEnum.CANCELED && !rejectReason) {
      setStatusToUpdate(RefundStatusEnum.CANCELED);
      setIsOpen(true);
      return;
    }

    try {
      const PATH = `${API_URL_ORDER_SERVICE}${API_ENDPOINT.refund}/${id}`;
      const payload = {
        status: newStatus, rejectReason
      }
      setLoading(true)
      await callApi(PATH, {
        method: 'PUT',
        data: payload,
      });

      showToastNotification('success', `Status updated to ${newStatus}`);
      setLoading(false)
      onSucess();
    } catch (error) {
      ThrowError(error)
      setLoading(false)
    }
  };

  const handleSubmitCancellation = () => {
    if (rejectReason.trim().length < 5) {
      showToastNotification(
        'danger',
        'Reason must be at least 5 characters long'
      );
      return;
    }
    if (rejectReason.trim()) {
      handleChangeStatus(refundId, statusToUpdate!, rejectReason);
    } else {
      showToastNotification(
        'danger',
        'Please provide a valid reason for cancellation',
      );
    }
  };


  const filteredRefundStatus =
    status === 'PENDING'
      ? [
        {
          value: 'SUCCEEDED',
          label: 'Succeeded',
          textClass: 'text-green-600',
          bgClass: 'bg-green-400',
        },
        {
          value: 'CANCELED',
          label: 'Canceled',
          textClass: 'text-red-600',
          bgClass: 'bg-red-400',
        },
      ]
      : [];

  // const filteredRefundStatus = [
  //   {
  //     value: 'PENDING',
  //     label: 'Awaiting Approval',
  //     textClass: 'text-green-600',
  //     bgClass: 'bg-green-400',
  //   },
  //   {
  //     value: 'CANCELED',
  //     label: 'Canceled',
  //     textClass: 'text-red-600',
  //     bgClass: 'bg-red-400',
  //   },
  //   {
  //     value: 'SUCCEEDED',
  //     label: 'Succeeded',
  //     textClass: 'text-green-600',
  //     bgClass: 'bg-green-400',
  //   },
  // ]

  return (
    <>
      <StatusDropdown
        value={status === 'PENDING' ? 'Awaiting Approval' : status}
        options={filteredRefundStatus}
        onChange={(newStatus) => { setShowUpdateModel(true), setStatusToUpdate(newStatus) }}
        canEditVal="order"
      />
      <Model
        show={isOpen}
        onClose={() => { setIsOpen(false), setRejectReason('') }}
        title="Write a reason for cancellation"
        height='max-h-88'
      >
        <div className='text-black'>
          <FormField
            type="textarea"
            rows={6}
            placeholder="Write a valid reason for the cancellation of refund request."
            value={rejectReason}
            onChange={(e) => handleReasonChange(e as React.ChangeEvent<HTMLInputElement>)}
          />
          <ErrorMessage message={errorMessage} />
        </div>
        <div className="mt-5 flex justify-end items-center">
          <button
            type="button"
            disabled={!!errorMessage}
            className="btn-primary"
            onClick={handleSubmitCancellation}
          >
            {loading ? <BtnLoader /> : 'Submit'}
          </button>
        </div>
      </Model>
      {
        showUpdateModel &&
        (
          <>
            <ConfirmationModel
              modelType='update'
              show={showUpdateModel}
              onClose={() => { setShowUpdateModel(false) }}
              onConfirm={() => handleChangeStatus(refundId, statusToUpdate!)}
              type={`order status to ${statusToUpdate?.toLocaleLowerCase()}`}
              subTitle='You want to update'
            />
          </>
        )
      }
    </>
  );
};

export default RefundStatus;
